const ajaxURL = adminurl.ajaxurl;

$(function(){
    $('.js-generate-invoice').on('click', function(){
        var order_id = $(this).data('id');

        var data = {
          action: 'generate_pdf_invoice',
          order_id: order_id
        }

        // Here is the ajax petition.
        jQuery.ajax({
            url : ajaxURL, // Here goes our WordPress AJAX endpoint.
            type : 'post',
            data : data,
            success : function( file ) {
                console.log(file)
                // You can craft something here to handle the message return
                window.open(file);

            },
            complete: function (data) {
               setTimeout(function(){
                   var success_data = {
                       action: 'delete_pdf',
                       order_id: order_id
                   }
                   $.ajax({
                       type: "post",
                       url: ajaxURL,
                       data: success_data,
                   });
               }, 1200);
            },
            fail : function( err ) {
                // You can craft something here to handle an error if something goes wrong when doing the AJAX request.
                alert( "There was an error: " + err );
            }
        });
    });


})